module.exports = __webpack_public_path__ + "img/icons/new/check-wh-75b0dcb6ad0732b04b8ea752adc0fd91.svg";